import React from 'react';
import i18next from 'i18next';

interface State {
  hasError: boolean;
  errorMessage: string;
}

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { hasError: false, errorMessage: '' };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, errorMessage: error?.message || String(error) };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ErrorBoundary] Uncaught error:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          background: '#f5f5f5',
          padding: '24px',
        }}>
          <div style={{
            maxWidth: '420px',
            textAlign: 'center',
            background: '#fff',
            borderRadius: '12px',
            padding: '32px 24px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          }}>
            <h1 style={{ fontSize: '20px', marginBottom: '12px', color: '#1a1a1a' }}>
              {i18next.t('errorBoundary.title')}
            </h1>
            <p style={{ fontSize: '14px', color: '#666', lineHeight: 1.5, marginBottom: '24px' }}>
              {i18next.t('errorBoundary.description')}
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: '10px 24px',
                fontSize: '14px',
                fontWeight: 600,
                color: '#fff',
                background: '#2563eb',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
              }}
            >
              {i18next.t('errorBoundary.reloadPage')}
            </button>
            {this.state.errorMessage && (
              <details style={{ marginTop: '20px', textAlign: 'left' }}>
                <summary style={{ fontSize: '12px', color: '#999', cursor: 'pointer' }}>
                  {i18next.t('errorBoundary.errorDetails')}
                </summary>
                <pre style={{
                  marginTop: '8px',
                  padding: '8px',
                  background: '#f9fafb',
                  borderRadius: '6px',
                  fontSize: '11px',
                  color: '#666',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  maxHeight: '120px',
                  overflow: 'auto',
                }}>
                  {this.state.errorMessage}
                </pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
